module.exports = __webpack_public_path__ + "static/drive5-min-e349f654a6ea731c1a807945736e6da7.png";